export default "__VITE_ASSET__z5xwzZPR__"